import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

function ViewSubscriptions() {
  return (
    <div className="contentAdmin bg-adminbg p-4" style={{ fontFamily: "Inter, sans-serif" }}>
      <div className=" bg-white  my-5 rounded-md  ">
        <div className="">
          <Link to={"/admin-dashboard/subscriptions"}>
            <button className="text-gray-600 font-semibold text-lg ">← Back </button>
          </Link>
          <div className="text-xl font-semibold px-2 py-7">Billing History</div>
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th justifySelf={"center"}>Date</Th>
                  <Th>Plan Details</Th>
                  <Th>Expires on</Th>
                  <Th>Transaction ID</Th>
                  <Th>Amount</Th>
                  <Th>Status</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody flex={"col"} gap={"100px"}>
                <Tr>
                  <Td>
                    07 May, 2024 <br />
                    <div className="py-2 opacity-80">01:13 AM</div>
                  </Td>
                  <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                  <Td>30 May, 2024</Td>
                  <Td>#562451646131</Td>
                  <Td>₹708</Td>
                  <Td>
                    <Badge colorScheme="red">Failed</Badge>
                  </Td>
                  <Td>Contact Us</Td>
                </Tr>
                <Tr>
                  <Td>
                    07 May, 2024 <br />
                    <div className="py-2 opacity-80">01:13 AM</div>
                  </Td>
                  <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                  <Td>30 May, 2024</Td>
                  <Td>#562451646131</Td>
                  <Td>₹708</Td>
                  <Td>
                    <Badge colorScheme="red">Failed</Badge>
                  </Td>
                  <Td>Contact Us</Td>
                </Tr>
                <Tr>
                  <Td>
                    07 May, 2024 <br />
                    <div className="py-2 opacity-80">01:13 AM</div>
                  </Td>
                  <Td fontWeight={"semibold"}>Job Posting Plan</Td>
                  <Td>30 May, 2024</Td>
                  <Td>#562451646131</Td>
                  <Td>₹708</Td>
                  <Td>
                    <Badge colorScheme="green">Successful</Badge>
                  </Td>
                  <Td>Contact Us</Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default ViewSubscriptions;
